var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 8.4667 8.4667",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.22679 0 0 .23954 .075595 .38978)",
    strokeWidth: 1.1352
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.4 2.9c-0.3-0.2-0.7-0.1-1 0.1l-9.7 7h-6.7c-0.6 0-1 0.4-1 1v10c0 0.6 0.4 1 1 1h6.7l9.7 7.1c0.2 0.1 0.4 0.2 0.6 0.2s0.3 0 0.5-0.1c0.3-0.2 0.5-0.5 0.5-0.9v-24.5c0-0.4-0.2-0.8-0.6-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.138 7.1465c-0.50911-0.50911-1.2728-0.50911-1.7819 0-0.50911 0.50911-0.50911 1.2728 0 1.7819 1.9091 1.7819 2.9274 4.2001 2.9274 6.7457 0 2.5455-1.0182 4.9638-2.9274 6.7457-0.50911 0.50911-0.50911 1.2728 0 1.7819 0.25455 0.25455 0.63638 0.38183 0.89094 0.38183s0.63638-0.12728 0.89094-0.38183c2.4183-2.291 3.691-5.2183 3.691-8.5275 0-3.3092-1.2728-6.2365-3.691-8.5275z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.967 11.141c-0.56357-0.56357-1.4089-0.56357-1.9725 0.14089-0.56357 0.56357-0.42268 1.4089 0.14089 1.9725 0.70446 0.70446 1.1271 1.6907 1.1271 2.677 0 0.98625-0.42268 1.9725-1.1271 2.677-0.56357 0.56357-0.56357 1.4089-0.14089 1.9725 0.28178 0.28178 0.70446 0.42268 0.98625 0.42268 0.28178 0 0.70446-0.14089 0.98625-0.42268 1.4089-1.268 2.1134-2.9587 2.1134-4.6494 0-1.6907-0.84536-3.6632-2.1134-4.7903z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.42859247d576f561222c894c41502ce8.svg";
export { ForwardRef as ReactComponent };